<template>

  <v-container id="appSignDepositSignPrivateKeyLoginPasswordReaderMainContainer" fluid class="pa-0">

    <div>

      <v-form ref="signInForm" autocomplete="off" :disabled="isDepositSignUserLogined || componentDisabled" @submit.prevent="submitSignIn">

        <div class="d-flex align-center">
          <app-text-field ref="clientId" v-model="clientId" label="appSignDepositSignPrivateKeyLoginPasswordReader.clientId" required
            clearable class="app-sign-text-field" :validate-on-blur="false">
          </app-text-field>

          <app-text-field ref="login" v-model="login" label="appSignDepositSignPrivateKeyLoginPasswordReader.login" required clearable
            class="ml-2 app-sign-text-field" :validate-on-blur="false">
          </app-text-field>
        </div>

        <div class="d-flex align-center">
          <app-password-field ref="password" v-model="password" label="appSignDepositSignPrivateKeyLoginPasswordReader.password" required
            :minPasswordLen="1" class="app-sign-text-field" :validate-on-blur="false">
          </app-password-field>
          <v-btn type="submit" :disabled="componentDisabled" color="primary" class="ml-2 mt-1">
            {{
                  isDepositSignUserLogined
                  ? $t('appSignDepositSignPrivateKeyLoginPasswordReader.signOut')
                  : $t('appSignDepositSignPrivateKeyLoginPasswordReader.signIn')
                }}
          </v-btn>
        </div>

      </v-form>

      <v-form ref="readKeyForm" autocomplete="off" :disabled="!isDepositSignUserLogined || componentDisabled"
        @submit.prevent="submitReadKey">

        <app-select ref="selectedKey" v-model="selectedKey" :items="keys" class="ma-0" item-text="keyFullName" item-value="keyName"
          label="appSignDepositSignPrivateKeyLoginPasswordReader.keyName" required :validate-on-blur="false">
        </app-select>

        <div class="d-flex align-center" style="flex-basis: 50%; flex-shrink: 0">
          <app-password-field ref="keyPassword" v-model="keyPassword" label="appSignDepositSignPrivateKeyLoginPasswordReader.keyPassword"
            :minPasswordLen="1" class="app-sign-text-field" required :validate-on-blur="false">
          </app-password-field>
          <v-btn v-if="keyIsReaded" color="warning" class="ml-2 mt-1" @click="onResetBtnClicked">
            {{$t('buttons.removesign')}}
          </v-btn>
          <v-btn v-else type="submit" :disabled="readKeyLoginPswBtnDisabled" color="primary" class="ml-2 mt-1">
            {{$t('appSignDepositSignPrivateKeyLoginPasswordReader.readKey')}}
          </v-btn>
        </div>

      </v-form>

    </div>

    <div v-if="messageText" v-html="messageText" :class="[ 'info-panel pa-2', messageIsError ? 'error': 'success' ]">
    </div>

    <div v-if="warningText" v-html="warningText" class="info-panel pa-2 warning mt-1">
    </div>

  </v-container>

</template>

<script>
import AppPasswordField from '@/components/Common/AppPasswordField';
import AppSelect from '@/components/Common/AppSelect';
import AppTextField from '@/components/Common/AppTextField';
import { actions as _act } from '@/models/store.actions';
import { depositSignService } from '@/services/deposit-sign.service';
import AppSignBasePrivateKeyReader from '@/sign/components/AppSignBasePrivateKeyReader';
import { DepositSignAuthType, PrivateKeyType } from '@/sign/models/sign-constants';
import { depositSignUserSessionService } from '@/sign/services/deposit-sign-user-session-store.service';
import { getRecaptchaTokenIfNotAuthenticated } from '@/helpers/recaptha-helper';
import { isCancelledError } from '@/helpers/error-helper';

export default {
  name: 'AppSignDepositSignPrivateKeyLoginPasswordReader',
  extends: AppSignBasePrivateKeyReader,
  components: { AppPasswordField, AppSelect, AppTextField },
  inject: ['isMobileOnly'],
  data() {
    return {
      afterResetCallback: null,
      clientId: '',
      isDepositSignUserLogined: false,
      keyPassword: '',
      keyReaderType: DepositSignAuthType.LoginPassword,
      keys: [],
      login: '',
      password: '',
      selectedKey: '',
      depositSignUserSessionId: ''
    };
  },
  computed: {
    readKeyLoginPswBtnDisabled() {
      return this.componentDisabled || !this.isDepositSignUserLogined;
    }
  },
  created() {
    this.onComponentCreated();
  },
  mounted() {
    this.subscribeLoginPassword();
  },
  beforeDestroy() {
    this.unsubscribeLoginPassword();
  },
  methods: {
    fillStateFromSessionService() {
      let s = this.getUserSession();
      this.depositSignUserSessionId = s.depositSignUserSessionId;
      this.clientId = s.clientId;
      this.login = s.login;
      this.password = s.password;
      this.keys = s.keys;
      this.selectedKey = s.selectedKeyId;
      this.keyPassword = s.selectedKeyPassword;
      this.endUserOwnerInfo = s.endUserOwnerInfo;
      this.ownCertificates = s.ownCertificates;
      if (this.endUserOwnerInfo) {
        this.messageIsError = false;
        this.messageText = this.handleReadKeyResult(this.endUserOwnerInfo);
        this.messageText += this.handleGetOwnCertificatesResult(this.ownCertificates);
        this.keyIsReaded = true;
        this.$emit('keyReaded', {
          endUserOwnerInfo: this.endUserOwnerInfo,
          cert: this.ownCertificates
        });
      }
      this.isDepositSignUserLogined = true;
      this.setFocus();
    },
    fillStateFromStore() {
      let cloudProvider = this.getCloudProviderDataFromStore();
      this.clientId = cloudProvider.clientId || '';
      this.login = cloudProvider.login || '';
      this.setFocus();
    },
    getCloudProviderDataFromStore() {
      let cloudProvider = this.isSeal
        ? this.$store.getters[_act.SIGN_GET_CLOUD_PROVIDER_SEAL](this.signProvider)
        : this.$store.getters[_act.SIGN_GET_CLOUD_PROVIDER](this.signProvider);
      return cloudProvider || {};
    },
    getHtmlElementToFocus() {
      let el;
      if (!this.isDepositSignUserLogined) {
        if (!this.clientId && this.$refs.clientId) {
          el = this.$refs.clientId.$children[0];
        } else if (!this.login && this.$refs.login) {
          el = this.$refs.login.$children[0];
        } else if (!this.password && this.$refs.password) {
          let inputs = this.$refs.password.$el.children[1].getElementsByTagName('input');
          if (inputs && inputs.length) {
            el = inputs[0];
          }
        }
      } else if (!this.keyIsReaded) {
        if (!this.selectedKey && this.$refs.selectedKey) {
          el = this.$refs.selectedKey.$children[0];
        } else if (!this.keyPassword && this.$refs.keyPassword) {
          let inputs = this.$refs.keyPassword.$el.children[1].getElementsByTagName('input');
          if (inputs && inputs.length) {
            el = inputs[0];
          }
        }
      }
      return el;
    },
    async getOwnCertificates() {
      return this.ownCertificates;
    },
    async isDepositSignUserSessionExists(depositSignUserSessionId) {
      let isSessionExists = false;
      if (depositSignUserSessionId) {
        this.showLoading({}, true);
        try {
          isSessionExists = await depositSignService.isSessionExists(depositSignUserSessionId);
        } catch (error) {
          // ignored
        } finally {
          this.hideLoading();
        }
      }
      return isSessionExists;
    },
    mapKeys(keys) {
      this.keys = keys.map((k) => {
        let keyFullName = `${k.fullName}`.trim();
        if (k.org) {
          if (keyFullName) {
            keyFullName += ` (${k.org})`;
          } else {
            keyFullName = `${k.org}`;
          }
        }
        k.keyFullName = keyFullName;
        return k;
      });
      this.selectedKey = keys.length > 0 ? keys[0].keyName : null;
    },
    async onComponentCreated() {
      let session = this.getUserSession();
      if (session) {
        let serverSessionExists = await this.isDepositSignUserSessionExists(session.depositSignUserSessionId);
        if (serverSessionExists) {
          this.fillStateFromSessionService();
        } else {
          this.deleteUserSession();
          this.fillStateFromStore();
        }
      } else {
        this.fillStateFromStore();
        if (this.isSeal) {
          let s = depositSignUserSessionService.getUserSession(PrivateKeyType.Key);
          if (s && s.clientId === this.clientId && s.login === this.login && !!s.password) {
            this.password = s.password;
            await this.signIn();
          }
        }
      }
    },
    async onPrepareToSign() {
      let session = this.getUserSession();
      if (session) {
        let serverSessionExists = await this.isDepositSignUserSessionExists(session.depositSignUserSessionId);
        if (serverSessionExists) {
          let isResetRequired = this.keyIsReaded && this.selectedKey !== session.selectedKeyId;

          if (isResetRequired) {
            this.isDepositSignUserLogined = false;
            this.afterResetCallback = () => {
              this.fillStateFromSessionService();
              this.afterResetCallback = null;
            };
            this.sendResetMsg();
          } else {
            this.fillStateFromSessionService();
          }
        } else {
          this.isDepositSignUserLogined = false;
          this.sendResetMsg();
        }
      } else {
        if (this.isDepositSignUserLogined) {
          this.isDepositSignUserLogined = false;
          this.sendResetMsg();
        } else {
          this.fillStateFromStore();
          if (this.isSeal) {
            let s = depositSignUserSessionService.getUserSession(PrivateKeyType.Key);
            if (s && s.clientId === this.clientId && s.login === this.login && !!s.password) {
              this.password = s.password;
              this.$nextTick(async() => {
                await this.signIn();
              });
            }
          }
        }
      }
    },
    async readKey() {
      this.disableShowMsg();
      try {
        let { recaptchaToken, recaptchaType } = await getRecaptchaTokenIfNotAuthenticated();

        const certs = await depositSignService.readKey(
          this.depositSignUserSessionId,
          this.selectedKey,
          this.keyPassword,
          recaptchaToken,
          recaptchaType
        );

        if (certs && certs.length) {
          this.endUserOwnerInfo = certs[0];
          this.ownCertificates = certs.map((c) => ({ infoEx: c, data: null }));
        }

        this.saveStateToSessionService();
      } finally {
        this.enableShowMsg();
      }

      return this.endUserOwnerInfo;
    },
    async reset() {
      if (this.isDepositSignUserLogined) {
        await this.serverSessionLogout();
      }
      this.deleteUserSession();
      this.depositSignUserSessionId = '';
      this.password = '';
      this.isDepositSignUserLogined = false;
      this.keys = [];
      this.selectedKey = '';
      this.keyPassword = '';
      await this.resetBase();
      if (this.afterResetCallback) {
        this.afterResetCallback();
      }
    },
    saveCloudProviderToStore() {
      let act = this.isSeal ? _act.SIGN_MUT_CLOUD_PROVIDER_SEAL : _act.SIGN_MUT_CLOUD_PROVIDER;
      this.$store.commit(act, {
        selectedCloud: this.signProvider,
        cloudProvider: {
          clientId: this.clientId,
          login: this.login
        }
      });
    },
    sendResetMsg() {
      this.eventBus.$emit('app-sign-reset-private-key-from-child');
    },
    async serverSessionLogout() {
      if (this.depositSignUserSessionId) {
        this.disableShowMsg();
        let loader = this.showLoading({});
        try {
          await depositSignService.logout(this.depositSignUserSessionId);
        } catch (error) {
          // ignored
        } finally {
          this.enableShowMsg();
          loader.hide();
        }
      }
    },
    async signIn() {
      if (!this.$refs.signInForm || this.$refs.signInForm.validate()) {
        const loader = this.showLoading({});

        try {
          this.messageIsError = false;
          this.messageText = '';

          this.disableShowMsg();

          this.saveCloudProviderToStore();

          this.deleteUserSession();

          this.depositSignUserSessionId = depositSignUserSessionService.createSessionId();

          let { recaptchaToken, recaptchaType } = await getRecaptchaTokenIfNotAuthenticated();

          const keys = await depositSignService.login(
            this.depositSignUserSessionId,
            this.clientId,
            this.login,
            this.password,
            recaptchaToken,
            recaptchaType
          );

          this.mapKeys(keys);

          this.saveStateToSessionService();

          this.isDepositSignUserLogined = true;

          this.setFocus();
        } catch (error) {
          if (!isCancelledError(error)) {
            this.handleError(error, 'appSignDepositSignPrivateKeyLoginPasswordReader.signInError');
          }
        } finally {
          this.enableShowMsg();
          loader.hide();
        }
      }
    },
    async submitReadKey() {
      if (this.$refs.readKeyForm.validate()) {
        this.disableShowMsg();
        try {
          await this.readKeyClick();
        } finally {
          this.enableShowMsg();
        }
      }
    },
    submitSignIn() {
      if (this.isDepositSignUserLogined) {
        this.sendResetMsg();
      } else {
        this.signIn();
      }
    },
    subscribeLoginPassword() {
      this.eventBus.$on('app-sign-prepare', this.onPrepareToSign);
    },
    unsubscribeLoginPassword() {
      this.eventBus.$off('app-sign-prepare', this.onPrepareToSign);
    },
    async appendAdditionalSigningParams(prms) {
      if (prms) {
        if (!prms.data) prms.data = {};
        prms.data.depositSignUserSessionId = this.depositSignUserSessionId;
        prms.data.keyId = this.selectedKey;
        prms.data.keyPassword = this.keyPassword;
      }
      return prms;
    },
    async tryToReadKey() {
      if (!this.isDepositSignUserLogined) {
        await this.submitSignIn();
      }
      if (this.isDepositSignUserLogined) {
        await this.submitReadKey();
      }
    },
    onPrepareComponent() {
      this.$refs.signInForm.resetValidation();
      this.$refs.readKeyForm.resetValidation();
    },
    getUserSession() {
      return depositSignUserSessionService.getUserSession(this.privateKeyType);
    },
    deleteUserSession() {
      depositSignUserSessionService.deleteUserSession(this.privateKeyType);
    },
    saveStateToSessionService() {
      const s = {
        depositSignUserSessionId: this.depositSignUserSessionId,
        clientId: this.clientId,
        login: this.login,
        password: this.password,
        keys: this.keys,
        selectedKeyId: this.selectedKey,
        selectedKeyPassword: this.keyPassword,
        endUserOwnerInfo: this.endUserOwnerInfo,
        ownCertificates: this.ownCertificates
      };
      depositSignUserSessionService.saveUserSession(this.privateKeyType, s);
    }
  }
};
</script>
